import { TrackingEventNames as BaseTrackingEventNames } from '../../common/tracking/tracking-event-names.model';

export const TrackingEventNames = {
  ...BaseTrackingEventNames,
  DASHBOARDS_DATA_TABLE_DIALOG: 'dashboards_data_table_dialog'
};
